import React, {useState} from 'react';
import styled from 'styled-components';
import { SPACING } from '@govuk-react/constants';
import {
    Main,
    GridRow,
    GridCol,
    LeadParagraph,
    Paragraph,
    ListNavigation,
    Header,
    Tabs
} from 'govuk-react';
import { asAnchor } from '@govuk-react/hoc';
import { BREAKPOINTS } from '@govuk-react/constants';

const AnchorTag = asAnchor('a');

const Introduction = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_2
});

const ContentItem = styled('div')({
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_4,
    borderTop: 'solid 1px #bfc1c3'
});

const RelatedContent = styled('div')({
    borderTop: '2px solid #005ea5',
    paddingTop: SPACING.SCALE_4,
    paddingBottom: SPACING.SCALE_4
});

const TabsList = () => {

    const [tabIndex, setTabIsndex] = useState(0);
    const handleTabChange = newTabIndex => setTabIsndex(newTabIndex);

    function handleClick( e, index ) {
        const mql = window.matchMedia(`(min-width: ${BREAKPOINTS.TABLET})`);
        if (mql.matches) {
            e.preventDefault();
        }
        return handleTabChange(index);
    }

    return (
        <>
            <Main>
                <GridRow>
                    <GridCol columnTwoThirds>
                        <Introduction>
                            <Header level={1}>Layout 3</Header>
                            <LeadParagraph>
                                Phasellus vel bibendum elit. Aenean id nisi sit amet metus porta pulvinar quis at lorem. Curabitur quis vehicula erat. Nam rutrum efficitur dolor eu rutrum.
                            </LeadParagraph>
                            <Paragraph>
                                These containers and pages are only a proposal and are open for
                                discussion.
                            </Paragraph>
                        </Introduction>
                    </GridCol>
                </GridRow>
                <GridRow>
                    <GridCol columnTwoThirds>
                        <GridRow>
                            <GridCol>
                                <Tabs>
                                    <Tabs.Title>Content</Tabs.Title>
                                    <Tabs.List>
                                        <Tabs.Tab
                                            onClick={(event) => handleClick(event, 0)}
                                            selected={tabIndex === 0}
                                            href="#first-panel"
                                        >
                                            Title 1
                                        </Tabs.Tab>
                                        <Tabs.Tab
                                            onClick={(event) => handleClick(event, 1)}
                                            selected={tabIndex === 1}
                                            href="#second-panel"
                                        >
                                            Title 2
                                        </Tabs.Tab>
                                        <Tabs.Tab
                                            onClick={(event) => handleClick(event, 2)}
                                            selected={tabIndex === 2}
                                            href="#tirth-panel"
                                        >
                                            Title 3
                                        </Tabs.Tab>
                                    </Tabs.List>
                                    <Tabs.Panel selected={tabIndex === 0} id="first-panel">
                                        <Paragraph> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eleifend dignissim arcu a vulputate. Fusce fringilla sodales tempor. Maecenas finibus dolor lectus, at auctor nunc dapibus vel.
                                        </Paragraph>
                                        <Paragraph> Pellentesque iaculis, erat eget facilisis suscipit, libero dui semper leo, ut lacinia tellus nunc vitae quam. Sed in viverra purus.
                                            Vestibulum a neque nunc. Praesent aliquam massa quis nisi imperdiet, id commodo sem
                                            porttitor.
                                        </Paragraph>
                                        <Paragraph>Proin nulla magna, pellentesque eu quam eget, maximus dignissim ligula. Mauris
                                            iaculis nisl eget ligula mattis fringilla. Sed metus nisl, dignissim at dui eget, tincidunt
                                            maximus tellus
                                        </Paragraph>
                                    </Tabs.Panel>
                                    <Tabs.Panel selected={tabIndex === 1} id="second-panel">
                                        <Paragraph>Fusce tincidunt nisi varius mauris ullamcorper lacinia. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Phasellus suscipit purus sed odio lacinia tempor.</Paragraph>
                                        <Paragraph>Proin eleifend dignissim arcu a vulputate. Fusce fringilla sodales tempor. Maecenas finibus dolor lectus, at auctor nunc dapibus vel. Pellentesque iaculis, erat eget facilisis suscipit, libero dui semper leo, ut lacinia tellus nunc vitae quam.
                                        </Paragraph>
                                    </Tabs.Panel>
                                    <Tabs.Panel selected={tabIndex === 2} id="tirth-panel">
                                        <Paragraph>Vestibulum a neque nunc. Praesent aliquam massa quis nisi imperdiet, id commodo sem porttitor. Proin nulla magna, pellentesque eu quam eget, maximus dignissim ligula. Mauris iaculis nisl eget ligula mattis fringilla. Sed metus nisl, dignissim at dui eget, tincidunt maximus tellus       </Paragraph>
                                        <Paragraph>Mauris iaculis nisl eget ligula mattis fringilla. Sed metus nisl, dignissim at dui eget, tincidunt maximus tellus</Paragraph>

                                    </Tabs.Panel>
                                </Tabs>
                            </GridCol>
                        </GridRow>
                    </GridCol>
                    <GridCol columnOneThird>
                        <RelatedContent>
                            <Header level={4}>Related content</Header>
                            <ListNavigation listStyleType="none">
                                <AnchorTag href="https://example.com/link-a">Link A</AnchorTag>
                                <AnchorTag href="https://example.com/link-b">Link B</AnchorTag>
                                <AnchorTag href="https://example.com/link-c">Link C</AnchorTag>
                            </ListNavigation>
                        </RelatedContent>
                        <ContentItem>
                            <Header level={4}>Related content</Header>
                            <Paragraph>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                            </Paragraph>
                        </ContentItem>
                    </GridCol>
                </GridRow>
            </Main>


        </>

    )
};

export default TabsList;

